import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import { UserFieldsFragmentDoc } from '../../../fragments/userFields.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetVehicleProjectOverviewPageDataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetVehicleProjectOverviewPageDataQuery = { __typename?: 'Query', vehicleProjectMasterWithProjectDetails: Array<{ __typename?: 'VehicleProjectMasterWithProjectDetails', vehicleProjectMaster: { __typename?: 'VehicleProjectMaster', modelSeries: string, generation: string, derivates: Array<string>, isManuallyCreated: boolean, sopVsi?: any | null, eopVsi?: any | null, lastEvaluated?: any | null, lastTransfer?: any | null, transferStatus: Types.TransferStatus, id: string, createdAt?: any | null, modifiedAt?: any | null, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, requirementCounts: { __typename?: 'RequirementsCount', final: number, interim: number } }, vehicleProjects: Array<{ __typename?: 'VehicleProject', modelSeries: string, generation: string, derivative?: string | null, technology?: string | null, modelYear?: number | null, euLegislation?: boolean | null, deletionPeriod: number, willBeAnonymized: boolean, anonymous: boolean, isManuallyCreated: boolean, isElectro?: boolean | null, sopVsi?: any | null, eopVsi?: any | null, detVsi?: any | null, p10Vsi?: any | null, typStartVsi?: any | null, sysgenVsi?: any | null, wvtaVsi?: any | null, sosVsi?: any | null, posEtVsi?: any | null, posVsi?: any | null, name: string, id: string, createdAt?: any | null, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, markets: Array<{ __typename?: 'Market', id: string, name: string, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }>, driveVariants: Array<{ __typename?: 'DriveVariant', id: string, name: string, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }>, engineVariants: Array<{ __typename?: 'EngineVariant', id: string, name: string, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }>, gearboxVariants: Array<{ __typename?: 'GearboxVariant', id: string, name: string, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }>, bodyworkVariants: Array<{ __typename?: 'BodyworkVariant', id: string, name: string, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }>, activeTypeMarkets: Array<{ __typename?: 'ActiveTypeMarket', id: string, name: string, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }> }> }> };

export type GetVehicleProjectDetailsQueryVariables = Types.Exact<{
  generation: Types.Scalars['String'];
  modelSeries: Types.Scalars['String'];
}>;


export type GetVehicleProjectDetailsQuery = { __typename?: 'Query', vehicleProjectMasterByModelSeriesAndGeneration?: { __typename?: 'VehicleProjectMaster', derivates: Array<string>, eopVsi?: any | null, generation: string, id: string, lastEvaluated?: any | null, modelSeries: string, modifiedAt?: any | null, sopVsi?: any | null } | null, vehicleProjectsByModelSeriesAndGeneration: Array<{ __typename?: 'VehicleProject', anonymous: boolean, createdAt?: any | null, deletionPeriod: number, derivative?: string | null, detVsi?: any | null, eopVsi?: any | null, euLegislation?: boolean | null, generation: string, id: string, isElectro?: boolean | null, modelSeries: string, modelYear?: number | null, modifiedAt?: any | null, name: string, p10Vsi?: any | null, posEtVsi?: any | null, posVsi?: any | null, sopVsi?: any | null, sosVsi?: any | null, sysgenVsi?: any | null, typStartVsi?: any | null, willBeAnonymized: boolean, wvtaVsi?: any | null, technology?: string | null, driveVariants: Array<{ __typename?: 'DriveVariant', id: string, name: string, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }>, engineVariants: Array<{ __typename?: 'EngineVariant', id: string, name: string, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }>, gearboxVariants: Array<{ __typename?: 'GearboxVariant', id: string, name: string, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }>, bodyworkVariants: Array<{ __typename?: 'BodyworkVariant', id: string, name: string, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }> }> };

export type VehicleProjectUsersWithPermissionsQueryVariables = Types.Exact<{
  modelSeries: Types.Scalars['String'];
}>;


export type VehicleProjectUsersWithPermissionsQuery = { __typename?: 'Query', usersWithPermissions: Array<{ __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }> };

export type CreateVehicleProjectMutationVariables = Types.Exact<{
  input: Types.CreateVehicleProjectInput;
}>;


export type CreateVehicleProjectMutation = { __typename?: 'Mutation', createVehicleProject: { __typename?: 'VehicleProjectPayload', vehicleProject: Array<{ __typename?: 'VehicleProject', id: string }> } };

export type UpdateVehicleProjectMutationVariables = Types.Exact<{
  input: Types.UpdateVehicleProjectInput;
}>;


export type UpdateVehicleProjectMutation = { __typename?: 'Mutation', updateVehicleProject: { __typename?: 'VehicleProjectPayload', vehicleProject: Array<{ __typename?: 'VehicleProject', id: string }> } };

export type DeleteVehicleProjectMutationVariables = Types.Exact<{
  input: Types.DeleteVehicleProjectInput;
}>;


export type DeleteVehicleProjectMutation = { __typename?: 'Mutation', deleteVehicleProject: { __typename?: 'DeleteVehicleProjectPayload', vehicleProjectMaster?: { __typename?: 'VehicleProjectMaster', id: string } | null } };

export type AssignVehicleProjectRequirementsMutationVariables = Types.Exact<{
  input: Types.AssignVehicleProjectRequirementsInput;
}>;


export type AssignVehicleProjectRequirementsMutation = { __typename?: 'Mutation', assignVehicleProjectRequirements: { __typename?: 'AssignVehicleProjectRequirementsPayload', vehicleProjectMaster?: { __typename?: 'VehicleProjectMaster', id: string } | null } };

export type RemoveAssignedVehicleProjectRequirementsMutationVariables = Types.Exact<{
  input: Types.RemoveAssignedVehicleProjectRequirementsInput;
}>;


export type RemoveAssignedVehicleProjectRequirementsMutation = { __typename?: 'Mutation', removeAssignedVehicleProjectRequirements: { __typename?: 'RemoveAssignedVehicleProjectRequirementsPayload', vehicleProjectMaster?: { __typename?: 'VehicleProjectMaster', id: string } | null } };

export type UpdateProjectRelevanceByRequirementsMutationVariables = Types.Exact<{
  input: Types.UpdateProjectRelevanceByRequirementsInput;
}>;


export type UpdateProjectRelevanceByRequirementsMutation = { __typename?: 'Mutation', updateProjectRelevanceByRequirements: { __typename?: 'UpdateProjectRelevanceByRequirementsPayload', vehicleProjectMaster?: { __typename?: 'VehicleProjectMaster', id: string } | null } };

export type UpdateProjectRelevanceByRegulationsMutationVariables = Types.Exact<{
  input: Types.UpdateProjectRelevanceByRegulationsInput;
}>;


export type UpdateProjectRelevanceByRegulationsMutation = { __typename?: 'Mutation', updateProjectRelevanceByRegulations: { __typename?: 'UpdateProjectRelevanceByRegulationsPayload', vehicleProjectMaster?: { __typename?: 'VehicleProjectMaster', id: string } | null } };

export type AggregateVehicleProjectsMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type AggregateVehicleProjectsMutation = { __typename?: 'Mutation', aggregateVehicleProjects: string };

export type AggregateVehicleProjectGroupMutationVariables = Types.Exact<{
  modelSeries: Types.Scalars['String'];
  generation: Types.Scalars['String'];
}>;


export type AggregateVehicleProjectGroupMutation = { __typename?: 'Mutation', aggregateVehicleProjectGroup: boolean };


export const GetVehicleProjectOverviewPageDataDocument = gql`
    query GetVehicleProjectOverviewPageData {
  vehicleProjectMasterWithProjectDetails {
    vehicleProjectMaster {
      modelSeries
      generation
      derivates
      isManuallyCreated
      sopVsi
      eopVsi
      lastEvaluated
      lastTransfer
      transferStatus
      id
      createdAt
      modifiedAt
      createdBy {
        ...UserFields
      }
      modifiedBy {
        ...UserFields
      }
      requirementCounts {
        final
        interim
      }
    }
    vehicleProjects {
      modelSeries
      generation
      derivative
      technology
      modelYear
      euLegislation
      deletionPeriod
      willBeAnonymized
      anonymous
      isManuallyCreated
      isElectro
      sopVsi
      eopVsi
      detVsi
      p10Vsi
      typStartVsi
      sysgenVsi
      wvtaVsi
      sosVsi
      posEtVsi
      posVsi
      name
      id
      createdAt
      createdBy {
        ...UserFields
      }
      modifiedBy {
        ...UserFields
      }
      markets {
        id
        name
        createdBy {
          ...UserFields
        }
        modifiedBy {
          ...UserFields
        }
      }
      driveVariants {
        id
        name
        createdBy {
          ...UserFields
        }
        modifiedBy {
          ...UserFields
        }
      }
      engineVariants {
        id
        name
        createdBy {
          ...UserFields
        }
        modifiedBy {
          ...UserFields
        }
      }
      gearboxVariants {
        id
        name
        createdBy {
          ...UserFields
        }
        modifiedBy {
          ...UserFields
        }
      }
      bodyworkVariants {
        id
        name
        createdBy {
          ...UserFields
        }
        modifiedBy {
          ...UserFields
        }
      }
      activeTypeMarkets {
        id
        name
        createdBy {
          ...UserFields
        }
        modifiedBy {
          ...UserFields
        }
      }
    }
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetVehicleProjectOverviewPageDataQuery__
 *
 * To run a query within a React component, call `useGetVehicleProjectOverviewPageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVehicleProjectOverviewPageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehicleProjectOverviewPageDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVehicleProjectOverviewPageDataQuery(baseOptions?: Apollo.QueryHookOptions<GetVehicleProjectOverviewPageDataQuery, GetVehicleProjectOverviewPageDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVehicleProjectOverviewPageDataQuery, GetVehicleProjectOverviewPageDataQueryVariables>(GetVehicleProjectOverviewPageDataDocument, options);
      }
export function useGetVehicleProjectOverviewPageDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVehicleProjectOverviewPageDataQuery, GetVehicleProjectOverviewPageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVehicleProjectOverviewPageDataQuery, GetVehicleProjectOverviewPageDataQueryVariables>(GetVehicleProjectOverviewPageDataDocument, options);
        }
export type GetVehicleProjectOverviewPageDataQueryHookResult = ReturnType<typeof useGetVehicleProjectOverviewPageDataQuery>;
export type GetVehicleProjectOverviewPageDataLazyQueryHookResult = ReturnType<typeof useGetVehicleProjectOverviewPageDataLazyQuery>;
export type GetVehicleProjectOverviewPageDataQueryResult = Apollo.QueryResult<GetVehicleProjectOverviewPageDataQuery, GetVehicleProjectOverviewPageDataQueryVariables>;
export const GetVehicleProjectDetailsDocument = gql`
    query GetVehicleProjectDetails($generation: String!, $modelSeries: String!) {
  vehicleProjectMasterByModelSeriesAndGeneration(
    modelSeries: $modelSeries
    generation: $generation
  ) {
    derivates
    eopVsi
    generation
    id
    lastEvaluated
    modelSeries
    modifiedAt
    sopVsi
  }
  vehicleProjectsByModelSeriesAndGeneration(
    modelSeries: $modelSeries
    generation: $generation
  ) {
    anonymous
    createdAt
    deletionPeriod
    derivative
    detVsi
    eopVsi
    euLegislation
    generation
    id
    isElectro
    modelSeries
    modelYear
    modifiedAt
    name
    p10Vsi
    posEtVsi
    posVsi
    sopVsi
    sosVsi
    sysgenVsi
    typStartVsi
    willBeAnonymized
    wvtaVsi
    technology
    driveVariants {
      id
      name
      createdBy {
        ...UserFields
      }
      modifiedBy {
        ...UserFields
      }
    }
    engineVariants {
      id
      name
      createdBy {
        ...UserFields
      }
      modifiedBy {
        ...UserFields
      }
    }
    gearboxVariants {
      id
      name
      createdBy {
        ...UserFields
      }
      modifiedBy {
        ...UserFields
      }
    }
    bodyworkVariants {
      id
      name
      createdBy {
        ...UserFields
      }
      modifiedBy {
        ...UserFields
      }
    }
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetVehicleProjectDetailsQuery__
 *
 * To run a query within a React component, call `useGetVehicleProjectDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVehicleProjectDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehicleProjectDetailsQuery({
 *   variables: {
 *      generation: // value for 'generation'
 *      modelSeries: // value for 'modelSeries'
 *   },
 * });
 */
export function useGetVehicleProjectDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetVehicleProjectDetailsQuery, GetVehicleProjectDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVehicleProjectDetailsQuery, GetVehicleProjectDetailsQueryVariables>(GetVehicleProjectDetailsDocument, options);
      }
export function useGetVehicleProjectDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVehicleProjectDetailsQuery, GetVehicleProjectDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVehicleProjectDetailsQuery, GetVehicleProjectDetailsQueryVariables>(GetVehicleProjectDetailsDocument, options);
        }
export type GetVehicleProjectDetailsQueryHookResult = ReturnType<typeof useGetVehicleProjectDetailsQuery>;
export type GetVehicleProjectDetailsLazyQueryHookResult = ReturnType<typeof useGetVehicleProjectDetailsLazyQuery>;
export type GetVehicleProjectDetailsQueryResult = Apollo.QueryResult<GetVehicleProjectDetailsQuery, GetVehicleProjectDetailsQueryVariables>;
export const VehicleProjectUsersWithPermissionsDocument = gql`
    query VehicleProjectUsersWithPermissions($modelSeries: String!) {
  usersWithPermissions(modelSeries: $modelSeries) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useVehicleProjectUsersWithPermissionsQuery__
 *
 * To run a query within a React component, call `useVehicleProjectUsersWithPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehicleProjectUsersWithPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehicleProjectUsersWithPermissionsQuery({
 *   variables: {
 *      modelSeries: // value for 'modelSeries'
 *   },
 * });
 */
export function useVehicleProjectUsersWithPermissionsQuery(baseOptions: Apollo.QueryHookOptions<VehicleProjectUsersWithPermissionsQuery, VehicleProjectUsersWithPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VehicleProjectUsersWithPermissionsQuery, VehicleProjectUsersWithPermissionsQueryVariables>(VehicleProjectUsersWithPermissionsDocument, options);
      }
export function useVehicleProjectUsersWithPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VehicleProjectUsersWithPermissionsQuery, VehicleProjectUsersWithPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VehicleProjectUsersWithPermissionsQuery, VehicleProjectUsersWithPermissionsQueryVariables>(VehicleProjectUsersWithPermissionsDocument, options);
        }
export type VehicleProjectUsersWithPermissionsQueryHookResult = ReturnType<typeof useVehicleProjectUsersWithPermissionsQuery>;
export type VehicleProjectUsersWithPermissionsLazyQueryHookResult = ReturnType<typeof useVehicleProjectUsersWithPermissionsLazyQuery>;
export type VehicleProjectUsersWithPermissionsQueryResult = Apollo.QueryResult<VehicleProjectUsersWithPermissionsQuery, VehicleProjectUsersWithPermissionsQueryVariables>;
export const CreateVehicleProjectDocument = gql`
    mutation CreateVehicleProject($input: CreateVehicleProjectInput!) {
  createVehicleProject(input: $input) {
    vehicleProject {
      id
    }
  }
}
    `;
export type CreateVehicleProjectMutationFn = Apollo.MutationFunction<CreateVehicleProjectMutation, CreateVehicleProjectMutationVariables>;

/**
 * __useCreateVehicleProjectMutation__
 *
 * To run a mutation, you first call `useCreateVehicleProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVehicleProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVehicleProjectMutation, { data, loading, error }] = useCreateVehicleProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVehicleProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateVehicleProjectMutation, CreateVehicleProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVehicleProjectMutation, CreateVehicleProjectMutationVariables>(CreateVehicleProjectDocument, options);
      }
export type CreateVehicleProjectMutationHookResult = ReturnType<typeof useCreateVehicleProjectMutation>;
export type CreateVehicleProjectMutationResult = Apollo.MutationResult<CreateVehicleProjectMutation>;
export type CreateVehicleProjectMutationOptions = Apollo.BaseMutationOptions<CreateVehicleProjectMutation, CreateVehicleProjectMutationVariables>;
export const UpdateVehicleProjectDocument = gql`
    mutation UpdateVehicleProject($input: UpdateVehicleProjectInput!) {
  updateVehicleProject(input: $input) {
    vehicleProject {
      id
    }
  }
}
    `;
export type UpdateVehicleProjectMutationFn = Apollo.MutationFunction<UpdateVehicleProjectMutation, UpdateVehicleProjectMutationVariables>;

/**
 * __useUpdateVehicleProjectMutation__
 *
 * To run a mutation, you first call `useUpdateVehicleProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVehicleProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVehicleProjectMutation, { data, loading, error }] = useUpdateVehicleProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVehicleProjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVehicleProjectMutation, UpdateVehicleProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVehicleProjectMutation, UpdateVehicleProjectMutationVariables>(UpdateVehicleProjectDocument, options);
      }
export type UpdateVehicleProjectMutationHookResult = ReturnType<typeof useUpdateVehicleProjectMutation>;
export type UpdateVehicleProjectMutationResult = Apollo.MutationResult<UpdateVehicleProjectMutation>;
export type UpdateVehicleProjectMutationOptions = Apollo.BaseMutationOptions<UpdateVehicleProjectMutation, UpdateVehicleProjectMutationVariables>;
export const DeleteVehicleProjectDocument = gql`
    mutation DeleteVehicleProject($input: DeleteVehicleProjectInput!) {
  deleteVehicleProject(input: $input) {
    vehicleProjectMaster {
      id
    }
  }
}
    `;
export type DeleteVehicleProjectMutationFn = Apollo.MutationFunction<DeleteVehicleProjectMutation, DeleteVehicleProjectMutationVariables>;

/**
 * __useDeleteVehicleProjectMutation__
 *
 * To run a mutation, you first call `useDeleteVehicleProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVehicleProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVehicleProjectMutation, { data, loading, error }] = useDeleteVehicleProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteVehicleProjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVehicleProjectMutation, DeleteVehicleProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVehicleProjectMutation, DeleteVehicleProjectMutationVariables>(DeleteVehicleProjectDocument, options);
      }
export type DeleteVehicleProjectMutationHookResult = ReturnType<typeof useDeleteVehicleProjectMutation>;
export type DeleteVehicleProjectMutationResult = Apollo.MutationResult<DeleteVehicleProjectMutation>;
export type DeleteVehicleProjectMutationOptions = Apollo.BaseMutationOptions<DeleteVehicleProjectMutation, DeleteVehicleProjectMutationVariables>;
export const AssignVehicleProjectRequirementsDocument = gql`
    mutation AssignVehicleProjectRequirements($input: AssignVehicleProjectRequirementsInput!) {
  assignVehicleProjectRequirements(input: $input) {
    vehicleProjectMaster {
      id
    }
  }
}
    `;
export type AssignVehicleProjectRequirementsMutationFn = Apollo.MutationFunction<AssignVehicleProjectRequirementsMutation, AssignVehicleProjectRequirementsMutationVariables>;

/**
 * __useAssignVehicleProjectRequirementsMutation__
 *
 * To run a mutation, you first call `useAssignVehicleProjectRequirementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignVehicleProjectRequirementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignVehicleProjectRequirementsMutation, { data, loading, error }] = useAssignVehicleProjectRequirementsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignVehicleProjectRequirementsMutation(baseOptions?: Apollo.MutationHookOptions<AssignVehicleProjectRequirementsMutation, AssignVehicleProjectRequirementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignVehicleProjectRequirementsMutation, AssignVehicleProjectRequirementsMutationVariables>(AssignVehicleProjectRequirementsDocument, options);
      }
export type AssignVehicleProjectRequirementsMutationHookResult = ReturnType<typeof useAssignVehicleProjectRequirementsMutation>;
export type AssignVehicleProjectRequirementsMutationResult = Apollo.MutationResult<AssignVehicleProjectRequirementsMutation>;
export type AssignVehicleProjectRequirementsMutationOptions = Apollo.BaseMutationOptions<AssignVehicleProjectRequirementsMutation, AssignVehicleProjectRequirementsMutationVariables>;
export const RemoveAssignedVehicleProjectRequirementsDocument = gql`
    mutation RemoveAssignedVehicleProjectRequirements($input: RemoveAssignedVehicleProjectRequirementsInput!) {
  removeAssignedVehicleProjectRequirements(input: $input) {
    vehicleProjectMaster {
      id
    }
  }
}
    `;
export type RemoveAssignedVehicleProjectRequirementsMutationFn = Apollo.MutationFunction<RemoveAssignedVehicleProjectRequirementsMutation, RemoveAssignedVehicleProjectRequirementsMutationVariables>;

/**
 * __useRemoveAssignedVehicleProjectRequirementsMutation__
 *
 * To run a mutation, you first call `useRemoveAssignedVehicleProjectRequirementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAssignedVehicleProjectRequirementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAssignedVehicleProjectRequirementsMutation, { data, loading, error }] = useRemoveAssignedVehicleProjectRequirementsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveAssignedVehicleProjectRequirementsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAssignedVehicleProjectRequirementsMutation, RemoveAssignedVehicleProjectRequirementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAssignedVehicleProjectRequirementsMutation, RemoveAssignedVehicleProjectRequirementsMutationVariables>(RemoveAssignedVehicleProjectRequirementsDocument, options);
      }
export type RemoveAssignedVehicleProjectRequirementsMutationHookResult = ReturnType<typeof useRemoveAssignedVehicleProjectRequirementsMutation>;
export type RemoveAssignedVehicleProjectRequirementsMutationResult = Apollo.MutationResult<RemoveAssignedVehicleProjectRequirementsMutation>;
export type RemoveAssignedVehicleProjectRequirementsMutationOptions = Apollo.BaseMutationOptions<RemoveAssignedVehicleProjectRequirementsMutation, RemoveAssignedVehicleProjectRequirementsMutationVariables>;
export const UpdateProjectRelevanceByRequirementsDocument = gql`
    mutation UpdateProjectRelevanceByRequirements($input: UpdateProjectRelevanceByRequirementsInput!) {
  updateProjectRelevanceByRequirements(input: $input) {
    vehicleProjectMaster {
      id
    }
  }
}
    `;
export type UpdateProjectRelevanceByRequirementsMutationFn = Apollo.MutationFunction<UpdateProjectRelevanceByRequirementsMutation, UpdateProjectRelevanceByRequirementsMutationVariables>;

/**
 * __useUpdateProjectRelevanceByRequirementsMutation__
 *
 * To run a mutation, you first call `useUpdateProjectRelevanceByRequirementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectRelevanceByRequirementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectRelevanceByRequirementsMutation, { data, loading, error }] = useUpdateProjectRelevanceByRequirementsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectRelevanceByRequirementsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectRelevanceByRequirementsMutation, UpdateProjectRelevanceByRequirementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectRelevanceByRequirementsMutation, UpdateProjectRelevanceByRequirementsMutationVariables>(UpdateProjectRelevanceByRequirementsDocument, options);
      }
export type UpdateProjectRelevanceByRequirementsMutationHookResult = ReturnType<typeof useUpdateProjectRelevanceByRequirementsMutation>;
export type UpdateProjectRelevanceByRequirementsMutationResult = Apollo.MutationResult<UpdateProjectRelevanceByRequirementsMutation>;
export type UpdateProjectRelevanceByRequirementsMutationOptions = Apollo.BaseMutationOptions<UpdateProjectRelevanceByRequirementsMutation, UpdateProjectRelevanceByRequirementsMutationVariables>;
export const UpdateProjectRelevanceByRegulationsDocument = gql`
    mutation UpdateProjectRelevanceByRegulations($input: UpdateProjectRelevanceByRegulationsInput!) {
  updateProjectRelevanceByRegulations(input: $input) {
    vehicleProjectMaster {
      id
    }
  }
}
    `;
export type UpdateProjectRelevanceByRegulationsMutationFn = Apollo.MutationFunction<UpdateProjectRelevanceByRegulationsMutation, UpdateProjectRelevanceByRegulationsMutationVariables>;

/**
 * __useUpdateProjectRelevanceByRegulationsMutation__
 *
 * To run a mutation, you first call `useUpdateProjectRelevanceByRegulationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectRelevanceByRegulationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectRelevanceByRegulationsMutation, { data, loading, error }] = useUpdateProjectRelevanceByRegulationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectRelevanceByRegulationsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectRelevanceByRegulationsMutation, UpdateProjectRelevanceByRegulationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectRelevanceByRegulationsMutation, UpdateProjectRelevanceByRegulationsMutationVariables>(UpdateProjectRelevanceByRegulationsDocument, options);
      }
export type UpdateProjectRelevanceByRegulationsMutationHookResult = ReturnType<typeof useUpdateProjectRelevanceByRegulationsMutation>;
export type UpdateProjectRelevanceByRegulationsMutationResult = Apollo.MutationResult<UpdateProjectRelevanceByRegulationsMutation>;
export type UpdateProjectRelevanceByRegulationsMutationOptions = Apollo.BaseMutationOptions<UpdateProjectRelevanceByRegulationsMutation, UpdateProjectRelevanceByRegulationsMutationVariables>;
export const AggregateVehicleProjectsDocument = gql`
    mutation AggregateVehicleProjects {
  aggregateVehicleProjects
}
    `;
export type AggregateVehicleProjectsMutationFn = Apollo.MutationFunction<AggregateVehicleProjectsMutation, AggregateVehicleProjectsMutationVariables>;

/**
 * __useAggregateVehicleProjectsMutation__
 *
 * To run a mutation, you first call `useAggregateVehicleProjectsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAggregateVehicleProjectsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aggregateVehicleProjectsMutation, { data, loading, error }] = useAggregateVehicleProjectsMutation({
 *   variables: {
 *   },
 * });
 */
export function useAggregateVehicleProjectsMutation(baseOptions?: Apollo.MutationHookOptions<AggregateVehicleProjectsMutation, AggregateVehicleProjectsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AggregateVehicleProjectsMutation, AggregateVehicleProjectsMutationVariables>(AggregateVehicleProjectsDocument, options);
      }
export type AggregateVehicleProjectsMutationHookResult = ReturnType<typeof useAggregateVehicleProjectsMutation>;
export type AggregateVehicleProjectsMutationResult = Apollo.MutationResult<AggregateVehicleProjectsMutation>;
export type AggregateVehicleProjectsMutationOptions = Apollo.BaseMutationOptions<AggregateVehicleProjectsMutation, AggregateVehicleProjectsMutationVariables>;
export const AggregateVehicleProjectGroupDocument = gql`
    mutation AggregateVehicleProjectGroup($modelSeries: String!, $generation: String!) {
  aggregateVehicleProjectGroup(modelSeries: $modelSeries, generation: $generation)
}
    `;
export type AggregateVehicleProjectGroupMutationFn = Apollo.MutationFunction<AggregateVehicleProjectGroupMutation, AggregateVehicleProjectGroupMutationVariables>;

/**
 * __useAggregateVehicleProjectGroupMutation__
 *
 * To run a mutation, you first call `useAggregateVehicleProjectGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAggregateVehicleProjectGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aggregateVehicleProjectGroupMutation, { data, loading, error }] = useAggregateVehicleProjectGroupMutation({
 *   variables: {
 *      modelSeries: // value for 'modelSeries'
 *      generation: // value for 'generation'
 *   },
 * });
 */
export function useAggregateVehicleProjectGroupMutation(baseOptions?: Apollo.MutationHookOptions<AggregateVehicleProjectGroupMutation, AggregateVehicleProjectGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AggregateVehicleProjectGroupMutation, AggregateVehicleProjectGroupMutationVariables>(AggregateVehicleProjectGroupDocument, options);
      }
export type AggregateVehicleProjectGroupMutationHookResult = ReturnType<typeof useAggregateVehicleProjectGroupMutation>;
export type AggregateVehicleProjectGroupMutationResult = Apollo.MutationResult<AggregateVehicleProjectGroupMutation>;
export type AggregateVehicleProjectGroupMutationOptions = Apollo.BaseMutationOptions<AggregateVehicleProjectGroupMutation, AggregateVehicleProjectGroupMutationVariables>;